import { render } from "./Replacement.vue?vue&type=template&id=1702b117&scoped=true"
import script from "./Replacement.vue?vue&type=script&lang=js"
export * from "./Replacement.vue?vue&type=script&lang=js"

import "./Replacement.vue?vue&type=style&index=0&id=1702b117&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702b117"]])

export default __exports__